import {Injectable} from '@angular/core';
import {ParametrosCB} from '../../models/conciliacionbancaria/parametrosCB';
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';


@Injectable({
  providedIn: 'root'
})
export class ParametroConciliacionBancariaService {

  // params: any;
  diccionarioUrl: any;
  urlFinanzas: string;
  urlVdi: string;

  // urlDatosMaestros: string;

  constructor(private _commom: CommonService,
              private _util: UtilsService) {
    this.diccionarioUrl = moduloConciliacionBan.url.conciliacionBancaria;
    // this.urlDatosMaestros = this._util.getDatosMaestros();
    this.urlFinanzas = this._util.getFinanciero('');
    this.urlVdi = this._util.geturlVdi();
    // this.params = moduloConciliacionBan.url.parametros;
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancParam);
  }

  actualizarCampo(inObjeto: ParametrosCB) {
    return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancParam, inObjeto);
  }

  guardarParametros(inObjeto: ParametrosCB) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancParam, inObjeto);
  }

  deteleParametros(inIdBanco: string, inIdEmpresa: string) {
    return this._commom.peticionDeleteConHeader(this.urlFinanzas + this.diccionarioUrl.conciBancParam + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  getSelectorArchivo(inIdEmpresa: string, inIdBanco: string) {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.findFormato + `?idBanco=${inIdBanco}&idEmpresa=${inIdEmpresa}`);
  }

  procesarArchivoSap(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.uploadDocSAP, inObjet);
  }

  procesarArchivoCuerpo(inObjet: any) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.uploadDoc, inObjet);
  }

  getCobrosPendientes(payload: any) {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.autorizarCobros.getCobrosPendientes + `?fecha=${payload.date}&idBanco=${payload.idBanco}&nCuenta=${payload.bankAccount}&cliente=${payload.customer}&vendedor=${payload.seller}&agencia=${payload.agency}`);
  }

  cargarExtractoBancario(inObjet: any) {
    //return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.extractoBancario, inObjet);
    return this._commom.peticionPostConHeader(this.urlVdi + this.diccionarioUrl.extractoBancario, inObjet);
  }

  procesarCobro(payload: any) {
    //return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario+`?fechaExtracto=${payload.date}`);
    //return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.autorizarCobros.procesarCobro, payload);
    return this._commom.peticionPutConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.procesarCobro, payload);
  }

  procesarCobroMasive(payload: any) {
    //return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario+`?fechaExtracto=${payload.date}`);
    //return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.autorizarCobros.procesarCobro, payload);
    return this._commom.peticionPutConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.procesarCobroMasive, payload);
  }

  rechazarCobro(payload: any, motivo: any, infor: any, otro: any) {
    let rechazo = {
        colId: payload.cobro.cobroId,
        colSecuencia: payload.pagoDetalle.pagConsecutivo,
        rechazoMotivo: motivo,
        rechazoInformacion: infor,
        rechazoOtros: otro
      };
      console.log(rechazo);
      return this._commom.peticionDeleteConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.rechazarCobro + payload.cobro.cobroId + '/' + payload.pagoDetalle.pagConsecutivo, rechazo); //T.23147.n  
      //return this._commom.peticionDeleteConHeader(this.urlVdi + this.diccionarioUrl.autorizarCobros.rechazarCobro + payload.cobro.cobroId + '/' + payload.pagoDetalle.pagConsecutivo); //T.23147.o
  }

  ejecutarRechazoDirecto(idCobro: string, secuencia: number) {
    return this._commom.peticionGetConHeader(this.urlVdi + '/rechazo-cobro/' + idCobro + '/' + secuencia);
  }

  getAllExtractoBancario(payload: any) {
    //return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario+`?fechaExtracto=${payload.date}`);
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.getAllextractoBancario + `?fechaExtracto=${payload.fechaExtracto}&idBanco=${payload.idBanco}&idEmpresa=${payload.idEmpresa}&nCuenta=${payload.nCuenta}`);
  }

  // getBancoPorEmpresa(inIdEmpresa: string) {
  //     // http://172.25.4.31:8081/qrks/v1/dmaestros/api/services/banco/pkEmpresa/444
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.banco + inIdEmpresa);
  // }

  // getAllEmpresa() {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.empresa);
  // }


  //revisar esta funcion
  obtenerDatos(inIdBanco: string, inIdEmpresa: string) {
    // return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.obtenerConci +
    //     this.params.idempresa + inIdEmpresa + this.params.idBanco + inIdBanco);
  }


  // getCuentaPorBanco(inIdEmpresa: string, inIdBanco: string) {
  //     return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.diccionarioUrl.bancoCuenta + inIdEmpresa + '/' + inIdBanco);
  // }


}
